// Don't remove, important for live updates
import { CapacitorUpdater } from '@capgo/capacitor-updater';

export const capgoInit = () => {
  CapacitorUpdater.notifyAppReady();
};
// End